export const API_ERROR_MESSAGE_DEFAULT =
  'Something went wrong. Please try again later.'

export const API_DOWNLOAD_REQUEST_SUCCESS_MESSAGE =
  'An email with a download link will be sent shortly'

export const API_ALREADY_NOTIFIED_RES = 'Already Notified'
